import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter, Github, Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "../common/Logo";
import { StarMotif } from "../common/StarMotif";

export function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="relative overflow-hidden bg-[hsl(222_47%_5%)] text-white">
            <div className="absolute -left-24 -bottom-24 h-96 w-96 opacity-[0.07]">
                <StarMotif className="h-full w-full text-primary" label="RKS" labelColor="currentColor" />
            </div>
            <div className="container-app relative pt-20 pb-8">
                <div className="grid gap-12 lg:grid-cols-[1.4fr,1fr,1fr,1fr]">
                    <div>
                        <Logo variant="light" />
                        <p className="mt-5 max-w-sm text-sm text-white/60 leading-relaxed">
                            Strategic offshore technology partner for US and global enterprises. Product engineering, cloud, data, AI, quality, automation, and security — with senior engineers, transparent governance, and outcomes that hold up in production.
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            <a href="#" aria-label="LinkedIn" data-testid="footer-linkedin" className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-white/10 hover:border-primary hover:text-primary transition-colors">
                                <Linkedin className="h-4 w-4" strokeWidth={1.75} />
                            </a>
                            <a href="#" aria-label="Twitter" data-testid="footer-twitter" className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-white/10 hover:border-primary hover:text-primary transition-colors">
                                <Twitter className="h-4 w-4" strokeWidth={1.75} />
                            </a>
                            <a href="#" aria-label="GitHub" data-testid="footer-github" className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-white/10 hover:border-primary hover:text-primary transition-colors">
                                <Github className="h-4 w-4" strokeWidth={1.75} />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="font-heading font-semibold text-sm text-white">What We Do</h4>
                        <ul className="mt-4 space-y-2.5 text-sm text-white/60">
                            <li><Link to="/what-we-do/product-engineering" className="hover:text-white transition-colors">Product Engineering</Link></li>
                            <li><Link to="/what-we-do/cloud-devops" className="hover:text-white transition-colors">Cloud & DevOps</Link></li>
                            <li><Link to="/what-we-do/data-ai" className="hover:text-white transition-colors">Data & AI</Link></li>
                            <li><Link to="/what-we-do/analytics" className="hover:text-white transition-colors">Analytics</Link></li>
                            <li><Link to="/what-we-do/testing" className="hover:text-white transition-colors">Quality Engineering</Link></li>
                            <li><Link to="/what-we-do/intelligent-automation" className="hover:text-white transition-colors">Intelligent Automation</Link></li>
                            <li><Link to="/what-we-do/security" className="hover:text-white transition-colors">Security</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-heading font-semibold text-sm text-white">Company</h4>
                        <ul className="mt-4 space-y-2.5 text-sm text-white/60">
                            <li><Link to="/solutions" className="hover:text-white transition-colors">Industries</Link></li>
                            <li><Link to="/engagement-models" className="hover:text-white transition-colors">Engagement Models</Link></li>
                            <li><Link to="/products" className="hover:text-white transition-colors">Products</Link></li>
                            <li><Link to="/success-stories" className="hover:text-white transition-colors">Success Stories</Link></li>
                            <li><Link to="/blog" className="hover:text-white transition-colors">Tech Blog</Link></li>
                            <li><Link to="/cost-explorer" className="hover:text-white transition-colors">Cost Explorer</Link></li>
                            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-heading font-semibold text-sm text-white">Get in Touch</h4>
                        <ul className="mt-4 space-y-3 text-sm text-white/60">
                            <li className="flex items-start gap-2.5">
                                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0 text-primary" strokeWidth={1.75} />
                                <span>Building 9, Mindspace, Madhapur,<br/>Hyderabad, 500081</span>
                            </li>
                            <li className="flex items-start gap-2.5">
                                <Mail className="h-4 w-4 mt-0.5 flex-shrink-0 text-primary" strokeWidth={1.75} />
                                <a href="mailto:info@rkssystems.com" className="hover:text-white transition-colors">info@rkssystems.com</a>
                            </li>
                            <li className="flex items-start gap-2.5">
                                <Phone className="h-4 w-4 mt-0.5 flex-shrink-0 text-primary" strokeWidth={1.75} />
                                <a href="tel:+918309575095" className="hover:text-white transition-colors">+91 83095 75095</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/50">
                    <p>© {year} RKS Systems. All rights reserved.</p>
                    <div className="flex items-center gap-5">
                        <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
                        <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
                        <Link to="/sitemap" className="hover:text-white transition-colors">Sitemap</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
